import { observer } from 'mobx-react';
import { Layout } from '@roc/feature-app-core';
import { DataGrid, AgGridColumnProps, SelectField } from '@roc/ui';
import { useEffect, useState } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Box, Typography } from '@material-ui/core';
import { BusinessUnit, businessUnitOptions } from '@roc/feature-utils';

const columns: AgGridColumnProps[] = [
  {
    field: 'rmAe',
    headerName: 'RM/AE',
    minWidth: 160,
    maxWidth: 250,
    cellRenderer: 'nameRenderer',
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'totalBorrowers',
    headerName: 'Total Borrowers',
    minWidth: 60,
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'totalBrokers',
    headerName: 'Total Brokers',
    minWidth: 160,
    maxWidth: 250,
    cellRenderer: 'statusCellRenderer',
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'totalTpos',
    headerName: 'Total TPOs',
    minWidth: 160,
    maxWidth: 250,
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'activeBorrowers',
    headerName: 'Active Borrower',
    minWidth: 160,
    maxWidth: 250,
    cellRenderer: 'contentRenderer',
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'activeBrokers',
    headerName: 'Active Brokers',
    minWidth: 160,
    maxWidth: 250,
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'activeTpos',
    headerName: 'Active TPOs',
    minWidth: 160,
    maxWidth: 250,
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'totalLeads',
    headerName: 'Total Leads',
    minWidth: 160,
    maxWidth: 250,
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
];

export const SalesManagementDashboard = observer(() => {
  const { salesManagementStore } = useStore();
  const gridStore = salesManagementStore.salesManagementGridStore;
  const [businessUnit, setBusinessUnit] = useState<string>(null);

  const handleOnChange = (value) => {
    setBusinessUnit(value);
    salesManagementStore.setBusinessUnit(value);
    gridStore.fetchGridData();
  }

  useEffect(() => {
    gridStore.fetchGridData();
  }, [gridStore]);

  const onSortChanged = (params: any) => {
    const sortModel = params.api.getSortModel();
    gridStore.setSortModel(sortModel);
  };

  const onFilterChanged = (params: any) => {
    const filterModel = params.api.getFilterModel();
    gridStore.setFilterModel(filterModel);
  };

  return (
    <Layout>
      <Box display="flex" alignItems="center" style={{ gap: 12 }} p={1} pl={2} flexWrap="wrap">
        <Box>
          <SelectField
            value={businessUnit}
            options={businessUnitOptions}
            onChange={value => {
              handleOnChange(value)
            }}
            fullWidth
            variant={'outlined'}
            testId={'businessUnit'}
            style={{ height: '35px' }}
          />
        </Box>
      </Box>
      <DataGrid
        columns={columns}
        rows={gridStore.gridData.data?.rows ?? []}
        isLoading={gridStore.isLoading}
        showFilters={gridStore.showFilters}
        sortModel={gridStore.sortModel}
        filterModel={gridStore.filterModel}
        paginationData={gridStore.gridData.meta}
        setPageNumber={gridStore.setPageNumber}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
      />
    </Layout>
  );
});
